import classNames from 'classnames';
import Logo from '../../assets/images/logo.svg';
import { AppView } from '../Main/Main';
import { Button } from './Button';
import X from '../../assets/images/x.svg';
import Menu from '../../assets/images/menu.svg';
import { useState } from 'react';
import { linkTo } from '../Results/utils';

const LINK_CLASSES = "border-transparent border-b-[3px] hover:border-crayola-pink hidden xl:flex"
const MOBILE_LINK_CLASSES="w-full h-16 flex justify-center items-center hover:bg-crayola-blue hover:text-white"

export function NavBar({ view, onExit }: { view: AppView, onExit: () => void }) {
  const [showDropdown, setShowDropdown] = useState(false);
  const [showMenu, setShowMenu] = useState(false);

  return (
    <>
      {showMenu && <div
        className="flex z-40 rounded-b-2xl shadow-[0_4px_8px_0_rgba(0,0,0,0.15)] w-full bg-white top-16 md:top-24 xl:hidden fixed flex-col items-center text-crayola-dark-blue font-medium tracking-[3px]"
      >
        <button onClick={() => linkTo("https://crayola-creative-profile.squarespace.com/about-creativity")} className={MOBILE_LINK_CLASSES}>ABOUT CREATIVITY</button>
        <button onClick={() => linkTo("https://crayola-creative-profile.squarespace.com/about-the-tool")}  className={MOBILE_LINK_CLASSES}>ABOUT THE TOOL</button>
        <button onClick={() => linkTo("https://crayola-creative-profile.squarespace.com/about-the-result")}  className={MOBILE_LINK_CLASSES}>ABOUT THE RESULTS</button>
        <div className="mt-4 mb-6 md:hidden"><Button rightArrow text="TRY THE TOOL" type="outline" onClick={() => linkTo('https://www.crayola.com/CreativeStyles')} /></div>
      </div>}
      <div className={classNames(
        "fixed top-0 px-8 xl:ps-20 xl:pe-24 w-full h-16 md:h-24 flex items-center z-40",
        view === AppView.Survey ? 'justify-end' : 'justify-between',
        view === AppView.Intro ? 'bg-white/70' : 'bg-white'
      )}>
        {view !== AppView.Survey &&
          <div className="flex justify-between w-full items-center relative">
            <img src={Logo} alt="Crayola Logo" className="w-[135px] md:w-[179px]"/>
            <div className="flex items-center gap-6 lg:gap-12">
              <div
                className="flex justify-center items-center gap-12 text-crayola-dark-blue font-medium tracking-[3px]"
              >
                <button onClick={() => linkTo("https://crayola-creative-profile.squarespace.com/about-creativity")} className={LINK_CLASSES}>ABOUT CREATIVITY</button>
                <button onClick={() => linkTo("https://crayola-creative-profile.squarespace.com/about-the-tool")}  className={LINK_CLASSES}>ABOUT THE TOOL</button>
                <button onClick={() => linkTo("https://crayola-creative-profile.squarespace.com/about-the-result")}  className={LINK_CLASSES}>ABOUT THE RESULTS</button>
                <div className="hidden md:flex">
                  <Button rightArrow text="TRY THE TOOL" type="outline" onClick={() => linkTo('https://www.crayola.com/CreativeStyles')} />
                </div>
              </div>
              <button
                onClick={() => setShowMenu(!showMenu)}
                aria-label="Menu"
                className="flex xl:hidden"
              >
                <img src={Menu} alt="toggle menu" />
              </button>
            </div>
          </div>
        }
        {view === AppView.Survey && <header role="banner" className="w-full flex justify-between items-center">
          <span className="w-40 hidden md:block"></span>
          <img src={Logo} alt="Crayola Logo" className="w-[135px] md:w-[179px]" />
          <button className="flex items-center gap-4" onClick={() => setShowDropdown(!showDropdown)}>
            <span className="text-crayola-dark-blue hidden md:block font-semibold tracking-widest">Exit Tool</span>
            <img src={X} alt="x" />
          </button>
          {showDropdown &&
            <div className="w-[260px] p-4 absolute end-16 rounded-2xl top-20 bg-white flex flex-col items-center gap-4 shadow-[0_0_8px_0_rgba(0,0,0,0.25)]">
              <span className="text-xl font-semibold italic">Are You Sure?</span>
              <span className="text-lg text-center">If you exit the tool,<br/>you'll lose your progress.</span>
              <Button rightArrow onClick={() => setShowDropdown(false)} text="CANCEL" type="solid" />
              <button
                role="link"
                onClick={() => {
                  linkTo('https://www.crayola.com/CreativeStyles');
                  setShowDropdown(false);
                }}
                className="font-semibold tracking-[3px] cursor-pointer border-b-2 border-transparent hover:border-crayola-pink"
              >Yes, Exit Tool</button>
            </div>
          }
        </header>}
      </div>
    </>
  )
}